/**
 * @generated SignedSource<<a2fe501ba71c6da671356877691a6cbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SalesforceSendNotesPanelAutomationQuery$variables = {
  noteId: string;
};
export type SalesforceSendNotesPanelAutomationQuery$data = {
  readonly note: {
    readonly sendNoteAutomationIsActive?: boolean;
    readonly sendNoteToCrmAutomationIsValid?: boolean;
  } | null;
};
export type SalesforceSendNotesPanelAutomationQuery = {
  response: SalesforceSendNotesPanelAutomationQuery$data;
  variables: SalesforceSendNotesPanelAutomationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendNoteToCrmAutomationIsValid",
      "storageKey": null
    },
    {
      "alias": "sendNoteAutomationIsActive",
      "args": null,
      "kind": "ScalarField",
      "name": "sendNoteToSalesforceAutomationIsActive",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SalesforceSendNotesPanelAutomationQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SalesforceSendNotesPanelAutomationQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "24bf9e0627543f5cd28914e568a08610",
    "id": null,
    "metadata": {},
    "name": "SalesforceSendNotesPanelAutomationQuery",
    "operationKind": "query",
    "text": "query SalesforceSendNotesPanelAutomationQuery(\n  $noteId: ID!\n) {\n  note: node(id: $noteId) {\n    __typename\n    ... on Note {\n      sendNoteToCrmAutomationIsValid\n      sendNoteAutomationIsActive: sendNoteToSalesforceAutomationIsActive\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0c2003dee71db3be11082b4cb844318a";

export default node;
